<template>
  <div v-if="pass" class="vx-row">
    <div class="vx-col mb-3">
      <table>
        <tr>
          <td class="font-semibold">Тип пропуска</td>
          <td class="pl-4">
            <span class="text-primary">{{ pass.kind.name }}</span>
          </td>
        </tr>
        <tr>
          <td class="font-semibold">Даты пропуска</td>
          <td class="pl-4" v-if="pass.date_booked_to && pass.date_booked_from">
            Пропуск действует с
            <span class="text-primary">{{ pass.date_booked_from }}</span> до
            <span class="text-primary">{{ pass.date_booked_to }}</span>
          </td>
          <td class="pl-4" v-else>
            Пропуск действует
            <span class="text-primary">{{ pass.date_booked }}</span>
          </td>
        </tr>
        <tr>
          <td class="font-semibold">Адрес</td>
          <td class="pl-4">
            <p>
              <span class="text-primary">{{ pass.home.county_type.name }}</span
              >, участок #
              <span class="text-primary">{{ pass.home.homestead_number }}</span
              >, ул. <span class="text-primary">{{ pass.home.address }}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td class="font-semibold">Тип авто</td>
          <td class="pl-4">
            <span class="text-primary">{{ pass.car_type.name }}</span>
          </td>
        </tr>
        <tr>
          <td class="font-semibold">Марка авто</td>
          <td class="pl-4">
            <span class="text-primary">{{ pass.car }}</span>
          </td>
        </tr>
        <tr>
          <td class="font-semibold">Номер авто</td>
          <td class="pl-4">
            <span class="text-primary font-bold">{{ pass.car_number }}</span>
          </td>
        </tr>

        <tr v-if="pass.fill_name">
          <td class="font-semibold">ФИО на кого заявка</td>
          <td class="pl-4">
            <span class="text-primary">{{ pass.full_name }}</span>
          </td>
        </tr>
        <tr v-if="pass.passenger_number">
          <td class="font-semibold">Количество пассажиров</td>
          <td class="pl-4">
            <span class="text-primary font-bold">{{
              pass.passenger_number
            }}</span>
          </td>
        </tr>
        <tr v-if="pass.description">
          <td class="font-semibold">Примечание</td>
          <td class="pl-4">
            <span class="text-primary">{{ pass.description }}</span>
          </td>
        </tr>
        <tr>
          <td class="font-semibold">На гостя</td>
          <td class="pl-4">
            <span class="text-primary">{{ pass.is_guest ? "Да" : "Нет" }}</span>
          </td>
        </tr>

        <tr>
          <td class="font-semibold">Оплачен</td>
          <td class="pl-4">
            <span class="text-primary">{{ pass.is_paid ? "Да" : "Нет" }}</span>
          </td>
        </tr>
        <tr>
          <td class="font-semibold">Цена</td>
          <td class="pl-4">
            <span class="text-primary">{{ pass.price }}</span>
          </td>
        </tr>

        <tr v-if="pass.photo">
          <td class="font-semibold">Фото паспорта</td>
          <td class="pl-4">
            <a
              class="text-primary"
              icon-pack="feather"
              icon="icon-paperclip"
              target="_blank"
              :href="baseURL + pass.photo"
            >
              <feather-icon
                icon="PaperclipIcon"
                class="inline-block align-middle"
                svgClasses="w-4 h-4"
              />
              Фото паспорта
            </a>
          </td>
        </tr>
        <tr v-if="pass.passport_scan">
          <td class="font-semibold">Скан паспорта</td>
          <td class="pl-4">
            <a
              class="text-primary"
              icon-pack="feather"
              icon="icon-paperclip"
              target="_blank"
              :href="baseURL + pass.passport_scan"
            >
              <feather-icon
                icon="PaperclipIcon"
                class="inline-block align-middle"
                svgClasses="w-4 h-4"
              />
              Скан паспорта
            </a>
          </td>
        </tr>
      </table>
    </div>
    <div class="vx-col w-full">
      <vs-table
        :data="actionsPass"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> Тип проезда </vs-th>
          <vs-th> Дата </vs-th>
          <vs-th> Цена </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].kind == "entry" ? "Въезд" : "Выезд" }}
            </vs-td>

            <vs-td>
              {{ data[indextr].date }}
            </vs-td>

            <vs-td> {{ pass.price }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { passType, carType, countyType } from "@/.env";
import { DateTime } from "luxon";

export default {
  props: {
    idPass: { type: Number, required: true },
  },
  data() {
    return {
      pass: null,
      actionsPass: [],
    };
  },
  watch: {
    idPass() {
      this.getSimplePass();
    },
  },
  methods: {
    getSimplePass() {
      this.$vs.loading();

      this.$load(async () => {
        let res = (await this.$api.passes.getActionsPass(this.idPass)).data;

        res.marks.forEach((mark) => {
          mark.date = DateTime.fromISO(mark.date).toLocaleString(
            DateTime.DATETIME_SHORT
          );
        });

        this.actionsPass = res.marks;

        let pass = res.passs;

        pass.kind = passType.find((x) => x.id == pass.kind);
        pass.car_type = carType.find((x) => x.id == pass.car_type);
        pass.home.county_type = countyType.find(
          (x) => x.id == pass.home.county_type
        );

        if (pass.date_booked) {
          pass.date_booked = DateTime.fromFormat(
            pass.date_booked,
            "yyyy-MM-dd"
          ).toFormat("dd.MM.yyyy");
        }

        if (pass.date_booked_to) {
          pass.date_booked_to = DateTime.fromFormat(
            pass.date_booked_to,
            "yyyy-MM-dd"
          ).toFormat("dd.MM.yyyy");
        }

        if (pass.date_booked_from) {
          pass.date_booked_from = DateTime.fromFormat(
            pass.date_booked_from,
            "yyyy-MM-dd"
          ).toFormat("dd.MM.yyyy");
        }

        this.pass = res.passs;

        this.$vs.loading.close();
      });
    },
  },
};
</script>
